/**
 * 过滤树形数据
 * @param {Array} arr - 树形数据数组
 * @param {Function} predicate - 过滤条件函数
 * @returns {Array} 过滤后的数组
 */
export const filterTree = (arr, predicate) => {
  let newarr = [];
  arr.forEach(element => {
    if (predicate(element)) {
      newarr.push(element);
    } else {
      if (element.children && element.children.length > 0) {
        let redata = filterTree(element.children, predicate);
        if (redata && redata.length > 0) {
          let obj = {
            ...element,
            children: redata
          };
          newarr.push(obj);
        }
      }
    }
  });
  return newarr;
};

/**
 * 根据路径字符串获取对象属性值
 * @param {Object} obj - 对象
 * @param {string} str - 属性路径，如 'a.b.c' 或 'a[0].b'
 * @returns {*} 属性值
 */
export function GetProperty(obj, str) {
  if (!str) return '';
  str = str.replace(/\[(\w+)\]/g, ".$1");
  let arr = str.split(".");
  for (let i in arr) {
    obj = obj[arr[i]] || "";
  }
  return obj;
}

/**
 * 计算数组元素之和
 * @param {Array} arr - 数字数组
 * @returns {number} 总和
 */
export const getSum = (arr) => {
  return eval(arr.join("+"));
};

/**
 * 从数组末尾移除指定类型的第一个匹配项
 * @param {Array} array - 数组
 * @param {*} targetType - 目标类型值
 * @param {string} targetTypeName - 类型属性名
 * @returns {Array} 处理后的数组
 */
export const removeLastByType = (array, targetType, targetTypeName) => {
  const _arr = [...array];
  for (let i = _arr.length - 1; i >= 0; i--) {
    if (_arr[i][targetTypeName] === targetType) {
      _arr.splice(i, 1);
      return _arr;
    }
  }
  return _arr;
};

/**
 * 获取值的类型
 * @param {*} value - 任意值
 * @returns {string} 类型字符串
 */
export const getType = (value) => {
  if (value === null) return 'null';

  const basicType = typeof value;
  if (basicType !== 'object') return basicType;

  if (Array.isArray(value)) return 'array';

  const typeString = Object.prototype.toString.call(value);
  return typeString.slice(8, -1).toLowerCase();
};

/**
 * 检测对象中的所有值是否都是空值
 * @param {*} obj - 任意值
 * @param {Object} options - 配置选项
 * @returns {boolean} 是否全为空值
 */
export const isObjectEmptyValues = (obj, options = {}) => {
  const {
    considerZero = true,
    considerNaN = true,
    includeInherited = false,
    excludeSymbols = true
  } = options;

  if (obj == null) return true;

  if (typeof obj === 'string') {
    return obj.trim() === '';
  }

  if (typeof obj === 'number') {
    if (obj === 0 && considerZero) return true;
    if (isNaN(obj) && considerNaN) return true;
    return false;
  }

  if (typeof obj === 'boolean') {
    return false;
  }

  if (Array.isArray(obj)) {
    if (obj.length === 0) return true;
    return obj.every(item => isObjectEmptyValues(item, options));
  }

  if (typeof obj === 'object') {
    const keys = includeInherited ?
      Reflect.ownKeys(obj) :
      Object.keys(obj);

    const filteredKeys = excludeSymbols ?
      keys.filter(key => typeof key !== 'symbol') :
      keys;

    if (filteredKeys.length === 0) return true;

    return filteredKeys.every(key => isObjectEmptyValues(obj[key], options));
  }

  return false;
};


